module.exports = __webpack_public_path__ + "img/jindu-tuya.246aeeeb.png";